import { TOAST_INSTANCE } from './constants';

export default class Toast {
	/**
	 * Display an error toast message
	 *
	 * @param {string} message
	 * @param {number} [timeout=5000]
	 * @return {void}
	 */
	public static error(message: string, timeout: number = 5000): void {
		this.show(message, 'statusRed', timeout);
	}

	/**
	 * Display a success toast message
	 *
	 * @param {string} message
	 * @param {number} [timeout=5000]
	 * @return {void}
	 */
	public static success(message: string, timeout: number = 5000): void {
		this.show(message, 'statusGreen', timeout);
	}

	/**
	 * Display an info toast message
	 *
	 * @param {string} message
	 * @param {number} [timeout=5000]
	 * @return {void}
	 */
	public static info(message: string, timeout: number = 5000): void {
		this.show(message, 'primary', timeout);
	}

	/**
	 * Display a warning toast message
	 *
	 * @param {string} message
	 * @param {number} [timeout=5000]
	 * @return {void}
	 */
	public static warn(message: string, timeout: number = 5000): void {
		this.show(message, 'statusYellow', timeout);
	}

	/**
	 * Display a toast message with a custom color
	 *
	 * @param {string} message
	 * @param {string} color
	 * @param {number} [timeout=5000]
	 * @return {void}
	 */
	private static show(message: string, color: string = 'primary', timeout: number = 5000): void {
		TOAST_INSTANCE.message = message;
		TOAST_INSTANCE.color = color;
		TOAST_INSTANCE.timeout = timeout;
		TOAST_INSTANCE.showMessage = true;
	}
}
